export default __webpack_public_path__ + "static/media/number.8c15f626.svg";